import { css } from '@emotion/react';
import styled from '@emotion/styled';
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import { compose, layout, space } from 'styled-system';

import { forwardValidProp } from 'shopper/utils/style';

const StyledMargin = styled('div', {
  shouldForwardProp: (prop) => forwardValidProp(prop),
})`
  ${({ theme }) => css`
    margin: 0 auto;
    position: relative;
    width: 100%;

    ${theme.mediaQueries.lg} {
      width: ${theme.breakpoints[2]};
    }

    ${theme.mediaQueries.xl} {
      width: ${theme.breakpoints[3]};
    }
  `}
  ${compose(space, layout)}
`;

const LayoutMargin = ({ maxWidthOnMobileDevices, ...props }) => (
  <StyledMargin
    px={[maxWidthOnMobileDevices ? null : 4, null, null, 2]}
    {...props}
  />
);

LayoutMargin.defaultProps = {
  maxWidthOnMobileDevices: false,
};

LayoutMargin.propTypes = {
  maxWidthOnMobileDevices: PropTypes.bool,
  /**
   * Implements `styled-system` [flexbox](https://styled-system.com/api/#layout) utility
   */
  ...propTypes.layout,
  /**
   * Implements `styled-system` [space](https://styled-system.com/api/#space) utility
   */
  ...propTypes.space,
};

export default LayoutMargin;
